import { setLayout } from '@/features/layout/set-layout';
import { ReservationAgreementCreateGather } from '@/features/reservation-agreement/views/create-gather';
import { ReservationAgreementCreateLayout } from '@/features/reservation-agreement/views/create-layout';

export default setLayout({
  Page: ReservationAgreementCreateGather,
  InnerLayout: ReservationAgreementCreateLayout,
});
